import { Country } from './country';

/** Countries whose address has no state of its own: the state is always the city. */
export const COUNTRIES_WITH_STATE_EQUALS_CITY = [
  Country.Singapore,
  Country.UnitedKingdom,
  Country.UnitedArabEmirates,
] as const;

export const isCountryWithStateEqualCity = (country: string | undefined): boolean =>
  country !== undefined && (COUNTRIES_WITH_STATE_EQUALS_CITY as readonly string[]).includes(country);

/**
 * Single source for the state value of an address. In SG/GB/AE the state is not something the
 * shopper can supply — it is derived from the city — so the input is hidden and every write path
 * (saved addresses on web and native, checkout payloads, order creation) resolves it through here
 * instead of each call site inventing its own value.
 */
export const resolveStateForCountry = (country: string | undefined, city: string, state: string): string =>
  isCountryWithStateEqualCity(country) ? city : state;
